<template>
  <v-footer
    class="pa-0 page-footer"
    :class="$vuetify.display.smAndDown ? 'page-footer--mobile' : 'page-footer--desktop'"
  >
    <div class="page-footer__card">
      <div class="page-footer__brand">
        <img src="/img/icons/android-chrome-192x192-white.png" alt="" class="page-footer__logo">
        <div>
          <p class="page-footer__name">Katana</p>
          <p class="page-footer__copy">© {{ year }} <strong>InfographArt</strong></p>
        </div>
      </div>

      <nav class="page-footer__links">
        <router-link to="/help">Aide</router-link>
        <a href="mailto:hello@infographart.com">Nous contacter</a>
      </nav>

      <div class="page-footer__meta">
        <span class="page-footer__chip">
          <v-icon size="14">mdi-tag-outline</v-icon>v{{ version }}
        </span>
        <span v-if="gitSha" class="page-footer__chip">
          <v-icon size="14">mdi-source-branch</v-icon>{{ gitSha }}
        </span>
      </div>
    </div>
  </v-footer>
</template>

<script>
import packago from "../../package.json";

export default {
  name: "Bottom",
  data() {
    return {
      version: packago.version,
    };
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
    gitSha() {
      if (process.env.VUE_APP_GIT_SHA) return process.env.VUE_APP_GIT_SHA.slice(0, 7); else return false;
    },
  },
};
</script>

<style scoped>
.page-footer {
  background: transparent !important;
  display: block;
}

.page-footer--desktop {
  margin-top: 64px;
  padding: 0 24px 12px 84px !important;
}

.page-footer--mobile {
  margin-top: 32px;
  padding: 0 8px 8px !important;
}

.page-footer__card {
  padding: 24px 28px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px 32px;
  border-radius: var(--k-radius-lg);
  border: 1px solid var(--k-glass-border);
  background: var(--k-glass-2-bg);
  box-shadow: inset 0 1px 0 var(--k-glass-shine), var(--k-glass-shadow);
  -webkit-backdrop-filter: blur(var(--k-glass-blur-2)) saturate(160%);
  backdrop-filter: blur(var(--k-glass-blur-2)) saturate(160%);
}

.page-footer__brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-footer__logo {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  padding: 6px;
  background: rgba(var(--v-theme-primary), 0.9);
}

.page-footer__name {
  margin: 0;
  font-weight: 700;
  line-height: 1.2;
}

.page-footer__copy {
  margin: 0;
  font-size: 0.8125rem;
  opacity: 0.7;
}

.page-footer__links {
  display: flex;
  gap: 24px;
}

.page-footer__links a {
  color: inherit;
  font-size: 0.875rem;
  text-decoration: none;
  opacity: 0.75;
  transition: opacity 0.15s;
}

.page-footer__links a:hover {
  opacity: 1;
  text-decoration: underline;
}

.page-footer__meta {
  display: flex;
  gap: 8px;
}

.page-footer__chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-variant-numeric: tabular-nums;
  background: rgba(var(--v-theme-on-surface), 0.08);
}
</style>
